import { render, staticRenderFns } from "./_product.component.vue?vue&type=template&id=776f05ea"
import script from "./_product.component.vue?vue&type=script&lang=js"
export * from "./_product.component.vue?vue&type=script&lang=js"
import style0 from "./_product.component.vue?vue&type=style&index=0&id=776f05ea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports